export default __webpack_public_path__ + "static/media/enghien28.3c79b5a4.jpg";